import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
  border-radius: 10px;
  color: #fff;
  background-color: #465eb6;
  margin-bottom: 8px;

  svg {
    cursor: pointer;
  }
`;

export const IconButton = styled.button`
  border: 0px;
  background-color: transparent;
  cursor: pointer;
`;